import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as satrActionTypes from '../satrActionTypes';

/**
 * Update SAVR service provider flow
 */
const updateSATRServiceProviderFlow = function* updateSATRServiceProviderFlow() {
    while (true) {
        const {payload} = yield take(satrActionTypes.SUBMIT_SATR_SERVICE_PROVIDER_FORM);
        const {serviceAssignmentLineNo, serviceCaseId, serviceAssignmentData} = payload;

        yield* updateServiceAssignment({
            caller: satrActionTypes.SUBMIT_SATR_SERVICE_PROVIDER_FORM,
            assignmentType: efServiceAssignmentTypes.VEHICLE_RETURN,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: satrActionTypes.SUBMIT_SATR_SERVICE_PROVIDER_FORM},
        });
    }
};

export default updateSATRServiceProviderFlow;
